(function() {

    (function(root, factory) {
        if (typeof define === 'function' && define.amd) {
            return define(['jquery', 'waypoints'], factory);
        } else {
            return factory(root.jQuery);
        }
    })(this, function($) {
        var defaults, wrap, resize, stick, rightInView, scroll, isStuck;
        defaults = {
            vertical: true,
            horizontal: false,
            wrapper: '<div class="sticky-wrapper" />',
            stuckTopClass: 'stuck-top',
            stuckBottomClass: 'stuck-bottom',
            stuckLeftClass: 'stuck-left',
            stuckRightClass: 'stuck-right',
            stuckContainerBottomClass: 'stuck-container-bottom',
            stuckContainerRightClass: 'stuck-container-right',
            container: window,
            verticalOffset: undefined,
            horizontalOffset: undefined
        };
        wrap = function($elements, options) {
            $elements.each(function() {
                var $this;
                $this = $(this);
                if (!$this.data('wrapped')) {
                    var wrapperCss = {
                        width: $this.css('width'),
                        height: $this.css('height'),
                        position: $this.css('position'),
                        display: $this.css('display'),
                        'float': $this.css('float'),
                        'margin-top': $this.css('margin-top'),
                        'margin-bottom': $this.css('margin-bottom'),
                        'margin-left': $this.css('margin-left'),
                        'margin-right': $this.css('margin-right')
                    };
                    $this.wrap(options.wrapper);
                    var $wrapper = $this.parent();
                    $wrapper.css(wrapperCss);
                    $this.css({
                        width: $wrapper.css('width'),
                        height: $wrapper.css('height'),
                        'float': 'none',
                        margin: '0'
                    });
                    $this.data('wrapped', true);
                }
                return true;
            });
            return $elements.parent();
        };
        /* When the contents of a waypoint container have changed the sizes must be recalculated */
        resize = function($elements, options) {
            $elements.each(function() {
                var $this;
                $this = $(this);
                var $wrapper = $this.parent();
                $this.css('height', 'auto');
                $wrapper.css('height', $this.css('height'));
                $this.css('height', $wrapper.css('height'));
                $.waypoints('refresh');
                return true;
            });
            return $elements.parent();
        };
        isStuck = function($sticky, options) {
            return $sticky.hasClass(options.stuckTopClass) ||
                $sticky.hasClass(options.stuckBottomClass) ||
                $sticky.hasClass(options.stuckLeftClass) ||
                $sticky.hasClass(options.stuckRightClass);
        };
        stick = function($sticky, options, direction) {
            var shouldBeStuck = direction === 'down' || direction === 'right';
            if(direction === 'down' || direction === 'up') {
                var stuckVerticalClass = typeof options.stuckVerticalClass === 'function' ? options.stuckVerticalClass.call(this) : options.stuckVerticalClass;
                $sticky.toggleClass(stuckVerticalClass, shouldBeStuck);
            }
            else {
                $sticky.toggleClass(options.stuckHorizontalClass, shouldBeStuck);
            }
            if(isStuck($sticky, options)) {
                $sticky.css('position', 'fixed');
            }
            else {
                $sticky.css('position', 'static');
            }
            scroll($sticky, options);
        };
        scroll = function($sticky, options) {
            var top, left, bottom, right;
            if(isStuck($sticky, options)) {
                var isStuckBottom = $sticky.hasClass(options.stuckBottomClass);
                var isStuckVertical = $sticky.hasClass(options.stuckTopClass) || isStuckBottom;

                if(isStuckVertical) {
                    var isStuckContainerBottom = $sticky.hasClass(options.stuckContainerBottomClass);
                    if(isStuckBottom) {
                        top = 'auto';
                        bottom = isStuckContainerBottom ? $(window).scrollTop() - options.stuckContainerBottomInitialScrollTop : 0;
                    }
                    else {
                        top = typeof options.verticalOffset === 'function' ? options.verticalOffset.call(this) : options.verticalOffset;
                        bottom = 'auto';
                        if(isStuckContainerBottom) {
                            top -= $(window).scrollTop() - options.stuckContainerBottomInitialScrollTop;
                        }
                    }
                }
                else {
                    top = options.origTop-$(window).scrollTop(); bottom = 'auto';
                }

                var isStuckRight = $sticky.hasClass(options.stuckRightClass);
                var isStuckHorizontal = $sticky.hasClass(options.stuckLeftClass) || isStuckRight;
                if(isStuckHorizontal) {
                    var isStuckContainerRight = $sticky.hasClass(options.stuckContainerRightClass);
                    if(isStuckRight) {
                        left = 'auto';
                        right = isStuckContainerRight ? $(window).scrollLeft() - options.stuckContainerLeftInitialScrollLeft : 0;
                    }
                    else {
                        left = options.horizontalOffset; right = 'auto';
                        if(isStuckContainerBottom) {
                            left -= $(window).scrollLeft() - options.stuckContainerLeftInitialScrollLeft;
                        }
                    }
                }
                else {
                    left = options.origLeft-$(window).scrollLeft(); right = 'auto';
                }
            }
            else {
                top = left = bottom = right = 'auto';
            }
            $sticky.css('top', top);
            $sticky.css('bottom', bottom);
            $sticky.css('left', left);
            $sticky.css('right', right);
        };
        rightInView = function ($wrap, options) {
            var hOffset;
            var widthDiff = $wrap.outerWidth() - $(window).width();
            if (widthDiff > 0) {
                var context;
                if(options.context === window) {
                    context = $(options.context);
                }
                else {
                    context = $wrap.closest(options.context);
                }
                var contextWidth = context.outerWidth();
                hOffset = contextWidth - $wrap.outerWidth();
            } else {
                hOffset = 0;
            }
            return hOffset;
        };

        $.waypoints('extendFn', 'resize', function(options) {
            resize(this, options);
        });

        return $.waypoints('extendFn', 'sticky', function(options) {
            var $wrap, originalHandler;
            options = $.extend({}, $.fn.waypoint.defaults, defaults, options);
            if (options.vertical || options.horizontal) {
                $wrap = wrap(this, options);
                originalHandler = options.handler;
                //noinspection FunctionWithInconsistentReturnsJS
                options.handler = function (direction) {
                    var $sticky;
                    $sticky = $(this).children(':first');
                    stick($sticky, options, direction);
                    if (originalHandler != null) {
                        return originalHandler.call(this, direction);
                    }
                };

                // Vertical init
                var vOffset = options.verticalOffset;
                options.stuckVerticalClass = options.stuckTopClass;
                if (!vOffset) {
                    vOffset = function(){
                        var heightDiff = $wrap.outerHeight() - $(window).height();
                        return (heightDiff > 0) ? 'bottom-in-view' : 0;
                    };
                    options.stuckVerticalClass = function(){
                        var heightDiff = $wrap.outerHeight() - $(window).height();
                        return (heightDiff > 0) ? options.stuckBottomClass : options.stuckTopClass;
                    };
                }
                options.verticalOffset = vOffset;
                options.origTop = $wrap.offset().top;
                if (options.vertical) {
                    $wrap.waypoint($.extend({}, options, {horizontal: false, offset: vOffset}));
                }

                // Horizontal init
                var hOffset = options.horizontalOffset;
                options.stuckHorizontalClass = options.stuckLeftClass;
                if (!hOffset) {
                    var widthDiff = $wrap.outerWidth() - $(window).width();
                    hOffset = (widthDiff > 0) ? rightInView($wrap, options) : 0;
                    options.stuckHorizontalClass = (widthDiff > 0) ? options.stuckRightClass : options.stuckLeftClass;
                }
                options.horizontalOffset = hOffset;
                options.origLeft = $wrap.offset().left;
                if (options.horizontal) {
                    $wrap.waypoint($.extend({}, options, {horizontal: true, offset: hOffset}));
                }

                // Container init
                if(options.container !== window) {
                    var $sticky = $wrap.children(':first');
                    var $container = $sticky.closest(options.container);
                    $wrap.waypoint({
                        offset: function() {
                            var heightDiff = $wrap.outerHeight() - $(window).height();
                            return $sticky.outerHeight() - $container.outerHeight() - (heightDiff > 0 ? heightDiff : 0);
                        },
                        handler: function (direction) {
                            var shouldBeStuckContainer = direction === 'down';
                            $sticky.toggleClass(options.stuckContainerBottomClass, shouldBeStuckContainer);
                            options.stuckContainerBottomInitialScrollTop = $(window).scrollTop();
                            scroll($sticky, options);
                        }
                    });
                    $wrap.waypoint({
                        offset: function() {
                            var widthDiff = $wrap.outerWidth() - $(window).width();
                            return $sticky.outerWidth() - $container.outerHeight() - (widthDiff > 0 ? widthDiff : 0);
                        },
                        handler: function (direction) {
                            var shouldBeStuckContainer = direction === 'down';
                            $sticky.toggleClass(options.stuckContainerBottomClass, shouldBeStuckContainer);
                            options.stuckContainerLeftInitialScrollLeft = $(window).scrollLeft();
                        }
                    });
                }

                // Scroll init
                $(window).on('scroll', function () {
                    var $sticky = $wrap.children(':first');
                    scroll($sticky, options);
                });
            }
            return this;
        });
    });

}).call(this);
